module.exports = __webpack_public_path__ + "static/media/capsule.7291855f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/capsule.jpg
// module id = 1735
// module chunks = 0